import { TRevenda } from '../../../../../services/shopkeeper';
import { formataTelefone, formataCep, formataCpf, formataCnpj } from '../../../../../utils';

type State = {
	razaoSocial: string;
	fantasia: string;
	tipoDocumento: string;
	numeroDocumento: string;
	email: string;
	telefone: string;
	celular: string;
	estado: string;
	cidade: string;
	bairro: string;
	logradouro: string;
	cep: string;
	numeroLogradouro: string;
	complementoLogradouro: string;
};

type Action =
	| { type: 'SET_FIELD_VALUE'; field: string; payload: string }
	| { type: 'REPLACE_STATE'; payload: State };

export const shopDataInitialState: State = {
	razaoSocial: '',
	fantasia: '',
	tipoDocumento: '',
	numeroDocumento: '',
	telefone: '',
	celular: '',
	email: '',
	logradouro: '',
	numeroLogradouro: '',
	complementoLogradouro: '',
	bairro: '',
	cep: '',
	estado: '',
	cidade: '',
};

export const shopDataReducer = (state: State, action: Action): State => {
	switch (action.type) {
		case 'SET_FIELD_VALUE':
			const campo = action.field;
			let valor = '';

			switch (campo) {
				case 'telefone':
				case 'celular':
					valor = formataTelefone(action.payload);
					break;
				case 'cep':
					valor = formataCep(action.payload);
					break;
				case 'numeroDocumento':
					if (state.tipoDocumento === '1') {
						valor = formataCpf(action.payload);
					}

					if (state.tipoDocumento === '2') {
						valor = formataCnpj(action.payload);
					}

					break;
				default:
					valor = action.payload;
			}

			return {
				...state,
				[action.field]: valor,
			};
		case 'REPLACE_STATE':
			const documento = action.payload.numeroDocumento;
			let documentoFormatado = documento;

			if (state.tipoDocumento === '1') {
				documentoFormatado = formataCpf(action.payload.numeroDocumento);
			}

			if (state.tipoDocumento === '2') {
				documentoFormatado = formataCnpj(action.payload.numeroDocumento);
			}

			return {
				...action.payload,
				telefone: formataTelefone(action.payload.telefone),
				cep: formataCep(action.payload.cep),
				numeroDocumento: documentoFormatado,
			};
		default:
			return state;
	}
};

export const tranformResponseIntoForm = (shopkeeper: TRevenda): State => {
	const {
		razaoSocial,
		fantasia,
		tipoDocumento,
		numeroDocumento,
		email,
		telefone,
		celular,
		cep,
		estado,
		cidade,
		bairro,
		logradouro,
		numeroLogradouro,
		complementoLogradouro,
	} = shopkeeper;

	return {
		razaoSocial,
		fantasia,
		tipoDocumento,
		numeroDocumento,
		email,
		telefone,
		celular,
		cep,
		estado,
		cidade,
		bairro,
		logradouro,
		numeroLogradouro,
		complementoLogradouro,
	};
};
